<template>
	<view class="common-tabbar">
		<view class="placeholder">
			<view class="box"></view>
			<bottom-box></bottom-box>
		</view>
		<view class="content">
			<view class="box">
				<template v-for="(item, index) in tabbar" :key="index">
					<view
						class="item"
						:class="{ active: item.path == path }"
						@tap="item.path != path && $navigateTo(item.path)"
					>
						<view class="image-box">
							<!-- <view class="badge">
								<uv-badge
									v-if="item.path === '/pages/message/index'"
									type="error"
									max="99"
									:value="msgStore.unreadNum"
								></uv-badge>
							</view> -->
							<image :src="item.path == path ? item.actIcon : item.icon" mode="aspectFit" />
						</view>
						<view class="name">{{ item.text }}</view>
					</view>
				</template>
			</view>
			<bottom-box></bottom-box>
		</view>
	</view>
</template>

<script lang="ts" setup>
import { onShow } from '@dcloudio/uni-app';
import systemInfo from '@/stores/systemInfo';
import { onMounted, getCurrentInstance } from 'vue';

defineProps<{
	path?: string;
}>();

// const msgStore = useMessage();
const prjData = projectData();
const instance = getCurrentInstance();

const tabbar = computed(() => {
	const tabbar = [
		{
			text: '首页',
			path: '/pages/home',
			icon: '/static/images/home.png',
			actIcon: '/static/images/home-act.png',
		},
		{
			text: '商城',
			path: '/pages/goods/exchange',
			icon: '/static/images/shop.png',
			actIcon: '/static/images/shop-act.png',
		},
		{
			text: '我的',
			path: '/pages/mycenter/index',
			icon: '/static/images/mycenter.png',
			actIcon: '/static/images/mycenter-act.png',
		},
	];

	if (prjData.isOnline) {
		tabbar.splice(2, 0, {
			text: '联盟商铺',
			path: '/pages/intracity/index',
			icon: '/static/images/intracity.png',
			actIcon: '/static/images/intracity-act.png',
		});
	}

	return tabbar;
});

onShow(() => uni.hideTabBar({ fail: () => {} }));

onMounted(() => {
	prjData.fetchVersionData();
	uni
		.createSelectorQuery()
		.in(instance)
		.select('.common-tabbar .placeholder')
		.boundingClientRect(({ height }: any) => (systemInfo().th = height))
		.exec();
});
</script>

<style lang="scss" scoped>
.common-tabbar {
	.content {
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 99;
		width: 100%;
		background-color: #fff;
		border-top: #f0f0f8 2rpx solid;
	}
	.placeholder,
	.content {
		.box {
			height: 92rpx;
			display: flex;
			align-items: center;
			.item {
				flex: 1;
				height: 100%;
				@include center;
				flex-direction: column;
				.image-box {
					position: relative;
					display: flex;
					.badge {
						position: absolute;
						top: -10rpx;
						right: -15rpx;
						z-index: 2;
					}
					image {
						width: 52rpx;
						height: 52rpx;
					}
				}
				&.active .name {
					color: #333;
				}
				.name {
					margin-top: 4rpx;
					font-size: 20rpx;
					color: #999999;
					line-height: 1;
				}
			}
		}
	}
}
</style>
